import React, { useEffect, useState } from "react";
import {
  FaEdit,
  FaTrash,
  FaPlus,
  FaTimes,
  FaChevronRight,
  FaChevronLeft,
} from "react-icons/fa";
import { getData, postData, putData, deleteData } from "../../../services/FetchNodeservices";
import dayjs from "dayjs";

export default function TaskAllocation() {
  const user = JSON.parse(localStorage.getItem("USER"));
  const [rows, setRows] = useState([]);

  // Search & Pagination
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;

  // Modals
  const [addModal, setAddModal] = useState(false);
  const [editDrawer, setEditDrawer] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);

  // Form state
  const [form, setForm] = useState({
    req_id: "",
    assigned_to: "",
    assigned_by: user?.id,
    target_count: "",
    notes: "",
  });

  useEffect(() => {
    loadAssignments();
  }, []);

  const loadAssignments = async () => {
    const res = await getData(`task/fetch?user_id=${user.id}`);
    if (res.status) {
      setRows(res.data);
    }
  };

  const addTask = async () => {
    let res = await postData("task/add", form);
    if (res.status) {
      setAddModal(false);
      loadAssignments();
    }
  };

  const updateTask = async () => {
    let res = await putData(`task/update/${editDrawer.id}`, editDrawer);
    if (res.status) {
      setEditDrawer(null);
      loadAssignments();
    }
  };

  const deleteTask = async () => {
    let res = await deleteData(`task/delete/${deleteModal}`);
    if (res.status) {
      setDeleteModal(null);
      loadAssignments();
    }
  };

  /* SEARCH + PAGINATION */
  const filtered = rows.filter((row) =>
    row.profile?.toLowerCase().includes(search.toLowerCase()) ||
    row.company?.toLowerCase().includes(search.toLowerCase()) ||
    row.assigned_to_name?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / limit);
  const paginatedRows = filtered.slice((page - 1) * limit, page * limit);

  return (
    <div className="ml-72 mt-16 p-6 bg-gray-100 min-h-screen space-y-6">

      {/* Header */}
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-gray-800">Task Allocation</h2>

        {/* + Add Task Button */}
        <button
          onClick={() => setAddModal(true)}
          className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 active:scale-95"
        >
          <FaPlus /> Add Task
        </button>
      </div>

      {/* Search */}
      <div className="bg-white p-4 shadow rounded-md">
        <input
          type="text"
          placeholder="Search tasks..."
          className="border px-3 py-2 rounded w-full text-sm"
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="bg-white border rounded shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b text-gray-700">
            <tr>
              <th className="p-2 border-r">Req ID</th>
              <th className="p-2 border-r">Assigned To</th>
              <th className="p-2 border-r">Assigned By</th>
              <th className="p-2 border-r">Assigned At</th>
              <th className="p-2 border-r">Profile</th>
              <th className="p-2 border-r">Company</th>
              <th className="p-2 border-r">Target</th>
              <th className="p-2 border-r">Actions</th>
            </tr>
          </thead>

          <tbody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((row) => (
                <tr key={row.id} className="border-b hover:bg-gray-50">
                  <td className="p-2 border-r">{row.req_id}</td>
                  <td className="p-2 border-r">{row.assigned_to_name}</td>
                  <td className="p-2 border-r">{row.assigned_by_name}</td>
                  <td className="p-2 border-r">{row.assigned_at}</td>
                  <td className="p-2 border-r">{row.profile}</td>
                  <td className="p-2 border-r">{row.company}</td>
                  <td className="p-2 border-r">{row.target_count}</td>

                  <td className="p-2 flex gap-3">
                    <button
                      className="text-blue-600 hover:text-blue-800"
                      onClick={() => setEditDrawer(row)}
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="text-red-600 hover:text-red-800"
                      onClick={() => setDeleteModal(row.id)}
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-6 text-gray-400">
                  No tasks found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {filtered.length > 0 && (
        <div className="flex justify-between items-center bg-white p-4 rounded shadow border">
          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            className={`flex items-center gap-1 px-3 py-1 rounded text-sm ${
              page === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-600 text-white"
            }`}
          >
            <FaChevronLeft /> Prev
          </button>

          <span className="text-sm font-medium text-gray-600">
            Page {page} of {totalPages}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
            className={`flex items-center gap-1 px-3 py-1 rounded text-sm ${
              page === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-600 text-white"
            }`}
          >
            Next <FaChevronRight />
          </button>
        </div>
      )}

      {/* ===== ADD MODAL ===== */}
      {addModal && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white w-[400px] rounded shadow p-6 relative animate-fadeIn">
            <FaTimes
              className="absolute top-3 right-3 text-gray-600 hover:text-red-500 cursor-pointer"
              onClick={() => setAddModal(false)}
            />

            <h3 className="font-semibold text-gray-700 mb-4">Add Task</h3>

            <input
              placeholder="REQ ID"
              className="border p-2 w-full rounded mb-3"
              onChange={(e) => setForm({ ...form, req_id: e.target.value })}
            />
            <input
              placeholder="Assign To (User ID)"
              className="border p-2 w-full rounded mb-3"
              onChange={(e) => setForm({ ...form, assigned_to: e.target.value })}
            />
            <input
              type="number"
              placeholder="Target Count"
              className="border p-2 w-full rounded mb-3"
              onChange={(e) =>
                setForm({ ...form, target_count: e.target.value })
              }
            />
            <textarea
              placeholder="Notes"
              className="border p-2 w-full rounded mb-3"
              onChange={(e) => setForm({ ...form, notes: e.target.value })}
            />

            <button
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
              onClick={addTask}
            >
              Submit
            </button>
          </div>
        </div>
      )}

      {/* ===== EDIT DRAWER ===== */}
      {editDrawer && (
        <div className="fixed top-0 right-0 w-[350px] bg-white h-full shadow-xl p-6 z-50 animate-slideLeft">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-bold text-gray-700">Edit Task</h3>
            <FaTimes
              className="text-gray-600 hover:text-red-500 cursor-pointer"
              onClick={() => setEditDrawer(null)}
            />
          </div>

          <input
            placeholder="Target Count"
            className="border p-2 w-full rounded mb-3"
            value={editDrawer.target_count}
            onChange={(e) =>
              setEditDrawer({ ...editDrawer, target_count: e.target.value })
            }
          />

          <textarea
            placeholder="Notes"
            className="border p-2 w-full rounded mb-3"
            value={editDrawer.notes}
            onChange={(e) =>
              setEditDrawer({ ...editDrawer, notes: e.target.value })
            }
          />

          <select
            className="border p-2 w-full rounded mb-3"
            value={editDrawer.status}
            onChange={(e) =>
              setEditDrawer({ ...editDrawer, status: e.target.value })
            }
          >
            <option value="Pending">Pending</option>
            <option value="Completed">Completed</option>
            <option value="Expired">Expired</option>
          </select>

          <button
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
            onClick={updateTask}
          >
            Save Changes
          </button>
        </div>
      )}

      {/* ===== DELETE CONFIRM MODAL ===== */}
      {deleteModal && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-6 w-[320px] text-center shadow-xl">
            <h3 className="font-bold text-gray-700 mb-4">
              Delete this task?
            </h3>

            <div className="flex gap-3 justify-center">
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setDeleteModal(null)}
              >
                Cancel
              </button>

              <button
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                onClick={deleteTask}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
